import { StateSchema } from 'app/config/storeConfig/types';
import { StepData } from 'features/Stepper';
import { ZoneBasics } from '../types';

export const getZoneCreateOpenedState = (s: StateSchema): boolean => s.createZoneModal?.isOpened || false;
export const getZoneCreateSteps = (s: StateSchema): StepData[] => s.createZoneModal?.steps || [];
export const getZoneBasics = (s: StateSchema): Nullable<ZoneBasics> => s.createZoneModal?.basics || null;
export const getZoneSelectedBoxIds = (s: StateSchema): string[] => s.createZoneModal?.selectedBoxIds || [];
export const getZoneSelectedDoorIds = (s: StateSchema): string[] => s.createZoneModal?.selectedDoorIds || [];
export const getZoneSelectedUserIds = (s: StateSchema): string[] => s.createZoneModal?.selectedUserIds || [];
